import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// actions
import { error as createError } from "actions/category/create";
import { error as updateError } from "actions/category/update";

// core components
import EditForm from './editForm';

function EditDialog(props) {
    const { category, closeDialog, isOpen, isSubCategory, resetErrors, updated } = props;

    // Validation errors of a previous submit must not show up in a newly opened form
    useEffect(() => {
        if (isOpen) {
            resetErrors();
        }
    }, [isOpen]);

    useEffect(() => {
        if (updated) {
            closeDialog();
        }
    }, [updated]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
            // CKEditor balloons (link URL input) are rendered outside the dialog, the focus trap would steal their focus
            disableEnforceFocus
        >
            <DialogTitle>
                <FormattedMessage id={isSubCategory ? "category.form.sub.update.title" : "category.form.update.title"} />
            </DialogTitle>
            <DialogContent>
                <EditForm
                    closeDialog={closeDialog}
                    category={category}
                    initialValues={category}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        updated: state.category.update.updated,
    }
};

const mapDispatchToProps = dispatch => ({
    resetErrors: () => {
        dispatch(createError(null));
        dispatch(updateError(null));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EditDialog);
